import { render, staticRenderFns } from "./sider-bar.vue?vue&type=template&id=4221bb1e&scoped=true"
import script from "./sider-bar.vue?vue&type=script&lang=js"
export * from "./sider-bar.vue?vue&type=script&lang=js"
import style0 from "./sider-bar.vue?vue&type=style&index=0&id=4221bb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221bb1e",
  null
  
)

export default component.exports